import { render } from "./OnlineService.vue?vue&type=template&id=65b533e8"
import script from "./OnlineService.vue?vue&type=script&lang=js"
export * from "./OnlineService.vue?vue&type=script&lang=js"

import "./OnlineService.vue?vue&type=style&index=0&id=65b533e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__